var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrunkSmall = function SvgTrunkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 54,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#906925",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M11 1C5.477 1 1 5.477 1 11v14.5c0 14.912 12.088 27 27 27h17c5.523 0 10-4.477 10-10s-4.477-10-10-10H28a7 7 0 0 1-7-7V11c0-5.523-4.477-10-10-10Z",
    clipRule: "evenodd"
  })));
};
export default SvgTrunkSmall;